import(/* webpackMode: "eager" */ "/codebuild/output/src2418691668/src/minhistryofcloud/src/app/page.tsx")